import { render, staticRenderFns } from "./TournamentForm.vue?vue&type=template&id=426e1b5b&scoped=true"
import script from "./TournamentForm.vue?vue&type=script&lang=js"
export * from "./TournamentForm.vue?vue&type=script&lang=js"
import style0 from "./TournamentForm.vue?vue&type=style&index=0&id=426e1b5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426e1b5b",
  null
  
)

export default component.exports